<div class="content-header">
  <ng-content select="[header]"></ng-content>
</div>
<div class="content-body" cdk-scrollable>
  <ng-content select="[content]"></ng-content>
</div>
